import React, { useState } from 'react';

const TermsAndConditions = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          {/* Header */}
          <div className="text-center mb-5">
            <h1 className="display-4 mb-3">Terms and Conditions</h1>
            <p className="text-secondary">Welcome to KLM Paper Bags! These Terms and Conditions govern your use of our website and the purchase of our products. By accessing or using our website, you agree to comply with and be bound by the following terms. Please read them carefully.</p>
          </div>

          {/* Main Content */}
          <div className="accordion" id="termsAccordion">
            {/* Section 1 - General Information */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'general' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('general')}
                >
                  <span className="fs-5 fw-semibold">1. General Information</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'general' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <div className="mb-4">
                    <h3 className="h5 mb-3">1.1 Company Overview</h3>
                    <p>KLM is a paper bag manufacturing company specializing in packaging products, including:</p>
                    <ul className="list-group list-group-flush ms-4">
                      <li className="list-group-item border-0">• Twisted Handle Paper Bags</li>
                      <li className="list-group-item border-0">• SOS (Self-Opening Square) Paper Bags</li>
                      <li className="list-group-item border-0">• White Paper Bags</li>
                      <li className="list-group-item border-0">• Restaurant Takeaway Bags</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="h5 mb-3">1.2 Eligibility</h3>
                    <p>By using this website, you confirm that you are at least 18 years old or accessing it under the supervision of a parent or guardian.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 2 - Website Use */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'website' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('website')}
                >
                  <span className="fs-5 fw-semibold">2. Website Use</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'website' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <div className="mb-4">
                    <h3 className="h5 mb-3">2.1 Content Ownership</h3>
                    <p>All content, including images, text, logos, and designs on this website, is the property of KLM Paper Bags and is protected by copyright laws.</p>
                  </div>
                  <div className="mb-4">
                    <h3 className="h5 mb-3">2.2 Prohibited Activities</h3>
                    <p className="mb-2">Users are prohibited from:</p>
                    <ul className="list-group list-group-flush ms-4">
                      <li className="list-group-item border-0">• Copying or redistributing website content without written consent</li>
                      <li className="list-group-item border-0">• Using the website for illegal activities or purposes</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="h5 mb-3">2.3 Accuracy of Information</h3>
                    <p>We strive to ensure all product details, pricing, and descriptions are accurate. However, errors may occur, and we reserve the right to correct them.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 3 - Product Usage */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'product' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('product')}
                >
                  <span className="fs-5 fw-semibold">3. Product Usage</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'product' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <div className="mb-4">
                    <h3 className="h5 mb-3">3.1 Intended Use</h3>
                    <p>Our paper bags are designed for packaging purposes. Misuse or overloading beyond recommended limits may result in damage for which KLM is not responsible.</p>
                  </div>
                  <div>
                    <h3 className="h5 mb-3">3.2 Custom Orders</h3>
                    <p>For custom designs or bulk orders, additional terms may apply and will be discussed at the time of the order.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 4 - Privacy Policy */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'privacy' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('privacy')}
                >
                  <span className="fs-5 fw-semibold">4. Privacy Policy</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'privacy' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <div className="mb-4">
                    <h3 className="h5 mb-3">4.1 Data Collection</h3>
                    <p>We collect and use customer data in accordance with our Privacy Policy, which can be accessed on our website.</p>
                  </div>
                  <div>
                    <h3 className="h5 mb-3">4.2 Third-Party Sharing</h3>
                    <p>Customer data will not be shared with third parties except as required for order fulfillment or as mandated by law.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 5 - Limitation of Liability */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'liability' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('liability')}
                >
                  <span className="fs-5 fw-semibold">5. Limitation of Liability</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'liability' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <p>KLM is not liable for any indirect, incidental, or consequential damages resulting from the use of our products or website.</p>
                </div>
              </div>
            </div>

            {/* Section 6 - Governing Law */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'law' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('law')}
                >
                  <span className="fs-5 fw-semibold">6. Governing Law</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'law' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <p>These terms are governed by the laws of [Country/State]. Any disputes arising from these terms or the use of our website shall be resolved in the courts of [Jurisdiction].</p>
                </div>
              </div>
            </div>

            {/* Section 7 - Changes to Terms */}
            <div className="accordion-item mb-3 border rounded">
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${activeSection !== 'changes' ? 'collapsed' : ''}`}
                  type="button"
                  onClick={() => toggleSection('changes')}
                >
                  <span className="fs-5 fw-semibold">7. Changes to Terms and Conditions</span>
                </button>
              </h2>
              <div className={`accordion-collapse collapse ${activeSection === 'changes' ? 'show' : ''}`}>
                <div className="accordion-body">
                  <p>KLM reserves the right to update these Terms and Conditions at any time without prior notice. Changes will be posted on this page, and continued use of the website constitutes acceptance of the updated terms.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="card mt-5 border-0 bg-light">
            <div className="card-body p-4">
              <h2 className="h4 mb-4">8. Contact Us</h2>
              <p className="mb-3">For questions or concerns regarding these Terms and Conditions, please contact us:</p>
              <div className="ms-3">
                <p className="mb-2">Email: info@klmpaperbags.com</p>
                <p className="mb-2">Phone: [Insert Phone Number]</p>
                <p>Address: [Insert Company Address]</p>
              </div>
            </div>
          </div>

          {/* Agreement Notice */}
          <div className="text-center mt-5 text-secondary">
            <p className="mb-2">By using our website or purchasing our products, you agree to these Terms and Conditions.</p>
            <p>Thank you for choosing KLM Paper Bags!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;